var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 11,
    fill: "#079BAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17L19.1649 22.7154C19.8261 23.1783 20.1567 23.4097 20.5163 23.4993C20.8339 23.5785 21.1661 23.5785 21.4837 23.4993C21.8433 23.4097 22.1739 23.1783 22.8351 22.7154L31 17M15.8 30H26.2C27.8802 30 28.7202 30 29.362 29.673C29.9265 29.3854 30.3854 28.9265 30.673 28.362C31 27.7202 31 26.8802 31 25.2V18.8C31 17.1198 31 16.2798 30.673 15.638C30.3854 15.0735 29.9265 14.6146 29.362 14.327C28.7202 14 27.8802 14 26.2 14H15.8C14.1198 14 13.2798 14 12.638 14.327C12.0735 14.6146 11.6146 15.0735 11.327 15.638C11 16.2798 11 17.1198 11 18.8V25.2C11 26.8802 11 27.7202 11.327 28.362C11.6146 28.9265 12.0735 29.3854 12.638 29.673C13.2798 30 14.1198 30 15.8 30Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.60ceb6be430110af9e27106ecd353869.svg";
export { ForwardRef as ReactComponent };